/**
 * Global marker the Playwright E2E harness sets on `window` (via
 * `addInitScript`) before the app boots, to opt the Auth0 SDK into a
 * localStorage token cache that the test setup can seed programmatically
 * (ROPG). Only the Playwright harness sets it; ordinary human sessions leave it
 * unset and use the default in-memory cache, and production is hard-gated so the
 * marker can never enable localStorage there (see AuthProviderWithHistory).
 * Shared between the app and the Playwright harness — keep the two in sync.
 * @module common/auth/e2eAuthMarker
 */
export const E2E_AUTH_MARKER = '__E2E_AUTH__';
